import {HttpClient, HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Router} from '@angular/router';

import {Observable, throwError} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';

import {AUTH_LOGIN, ENROLMENT_LOGIN, PASSWORD} from '../utils/routing/routes.model';

// Models
import { MultipleApiResponse, User } from '@mocca-technologies/model';

import { CoreService } from './core.service';
import { environment } from 'src/environments/environment';

// TODO: Remove provided by root once ngrx is running
@Injectable({
  providedIn: 'root'
})
export class AuthHttpService {

  _user: User;

  constructor(
    private router: Router,
    private http: HttpClient,
    private coreService: CoreService
  ) {}

  login(body):Observable<HttpResponse<MultipleApiResponse>> {
    return this.http.post<MultipleApiResponse>(
      AUTH_LOGIN,
      body,
      {
        observe: 'response',
        withCredentials: true,
      }).pipe(
        tap((res: HttpResponse<MultipleApiResponse>) => {
          this._user = res?.body.responseObject as User;
          this.saveUser(res?.body.responseObject as User);
          return this._user;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(() => error);
        })
      );
  }

  loginEnrolment(body): Observable<HttpResponse<any>> {
    !environment.production && console.log('[AuthService] POST', ENROLMENT_LOGIN, { body });
    return this.http
      .post<any>(ENROLMENT_LOGIN, body, {
        observe: 'response',
        withCredentials: true,
      })
      .pipe(
        tap((res: any) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(() => error);
        }),
      );
  }

  logout(): void {
    this.router.navigate(['auth'], {replaceUrl: true})
      .then(_ => {
        this.coreService.setUser(null);
        localStorage.clear();
        window.location.reload();
      });
  }

  saveUser(user: User): void {
    !environment.production && console.log("saving user", user);
    localStorage.setItem('user', JSON.stringify(user));
  }

  getUser(): User {
    const user = JSON.parse(localStorage.getItem('user'));
    return user;
  }

  resetPassword(token: string, newPassword: string): Observable<HttpResponse<MultipleApiResponse>>{
    const body = {
      token: token,
      newPassword: newPassword,
    }
    return this.http.post<MultipleApiResponse>(
      PASSWORD,
      body,
      {
        observe: 'response',
        withCredentials: true,
      }).pipe(
        tap((res:HttpResponse<MultipleApiResponse>) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(() => error);
        })
    );
  }

  requestNewPassword(username: string, email: string):Observable<HttpResponse<MultipleApiResponse>>{
    const body = {
      username: username,
      email: email,
    }
    return this.http.post<MultipleApiResponse>(
      PASSWORD,
      body,
      {
        observe: 'response',
        withCredentials: true,
      }).pipe(
        tap((res:HttpResponse<MultipleApiResponse>) => {
          return res;
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(() => error);
        })
    );
  }
}
